import React from 'react'
import {View, Text} from "@react-pdf/renderer";

const TableHeader = () => {
  return (
    <View
    style={{
        flexDirection: "row",
        padding: "0px 10px"
    }}
>
    
    <View
        style={{
            width:"100%",
            flexDirection: "row"
        }}
    >
        <View
        style={{
            backgroundColor: "#666666",
            padding: "1px",
            width: "35%",
            borderWidth: "1px",
            borderColor: "#000",
            borderRightWidth: "0px",
            justifyContent: "center",
            alignItems: "center"
        }}
        >
            <Text
                style={{
                    fontSize: "7px",
                    color: "#fff",
                    textAlign: "center"
                }}
            >
                Component
            </Text>
        </View>
        <View
        style={{
            backgroundColor: "#666666",
            padding: "1px",
            width: "5%",
            borderWidth: "1px",
            borderColor: "#000",
            borderRightWidth: "0px",
            justifyContent: "center",
            alignItems: "center"
        }}
        >
            <Text
                style={{
                    fontSize: "7px",
                    color: "#fff",
                    textAlign: "center"
                }}
            >
                QTY
            </Text>
        </View>
        <View
        style={{
            backgroundColor: "#666666",
            padding: "1px",
            width: "15%",
            borderWidth: "1px",
            borderColor: "#000",
            borderRightWidth: "0px",
            justifyContent: "center",
            alignItems: "center"
        }}
        >
            <Text
                style={{
                    fontSize: "7px",
                    color: "#fff",
                    textAlign: "center"
                }}
            >
                Evaluation
            </Text>
        </View>
        <View
        style={{
            backgroundColor: "#666666",
            padding: "1px",
            width: "15%",
            borderWidth: "1px",
            borderColor: "#000",
            borderRightWidth: "0px",
            justifyContent: "center",
            alignItems: "center"
        }}
        >
            <Text
                style={{
                    fontSize: "7px",
                    color: "#fff",
                    textAlign: "center"
                }}
            >
                Class.
            </Text>
        </View>
        <View
        style={{
            backgroundColor: "#666666",
            padding: "1px",
            width: "25%",
            borderWidth: "1px",
            borderColor: "#000",
            borderRightWidth: "0px",
            justifyContent: "center",
            alignItems: "center"
        }}
        >
            <Text
                style={{
                    fontSize: "7px",
                    color: "#fff",
                    textAlign: "center"
                }}
            >
                Pic
            </Text>
        </View>
        <View
        style={{
            backgroundColor: "#666666",
            padding: "1px",
            width: "5%",
            borderWidth: "1px",
            borderColor: "#000",
            justifyContent: "center",
            alignItems: "center"
        }}
        >
            <Text
                style={{
                    fontSize: "7px",
                    color: "#fff",
                    textAlign: "center"
                }}
            >
                Note
            </Text>
        </View>
    </View>
</View>
  )
}

export default TableHeader